import axios from 'axios';
import { apiCROMO } from "../../config.tsx"

export const clientCromo = axios.create({ baseURL: apiCROMO });
